var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      class: _vm.textClasses,
      attrs: { tabindex: "0", href: "#" },
      on: {
        keydown: [
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
            )
              return null
            return _vm.$emit("listItemBlur")
          },
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
            )
              return null
            $event.stopPropagation()
            $event.preventDefault()
            return _vm.$emit("listItemBlur")
          },
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "down", 40, $event.key, [
                "Down",
                "ArrowDown",
              ])
            )
              return null
            $event.preventDefault()
          },
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
            )
              return null
            $event.preventDefault()
          },
        ],
        keyup: [
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "down", 40, $event.key, [
                "Down",
                "ArrowDown",
              ])
            )
              return null
            return _vm.$parent.selectNextListItem($event)
          },
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
            )
              return null
            return _vm.$parent.selectPreviousListItem($event)
          },
        ],
        blur: _vm.processFocusOut,
      },
    },
    [
      _c("div", { staticClass: "sr-only" }, [
        _vm._v(_vm._s(_vm.screenReaderText)),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { "aria-hidden": "true" } },
        [
          _vm._t(
            "suggestion",
            function () {
              return [
                _c("span", { domProps: { innerHTML: _vm._s(_vm.htmlText) } }),
              ]
            },
            null,
            { data: _vm.data, htmlText: _vm.htmlText }
          ),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }